class MSharing extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      shareContent: '.m-product-addon--sharing',
      openButton: '[data-open-share]',
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    const {shareContent} = this.domNodes;
    if (shareContent && shareContent.innerHTML) {
      this.shareContent = shareContent.innerHTML;
      this.init();
    }
  }

  init() {
    this.domNodes.openButton && this.domNodes.openButton.classList.remove('m:hidden');
    this.modal = new MinimogTheme.Modal();
    addEventDelegate({
      selector: this.selectors.openButton,
      handler: (e) => {
        e.preventDefault();
        if (this.shareContent) {
          this.triggerElement = e.target.closest(this.selectors.openButton);
          const html = document.createElement('DIV');
          html.classList.add('m-sharing__content');
          html.innerHTML = this.shareContent;
          this.modal.appendChild(html);
          const colorScheme =
            html.querySelector('[data-color-scheme]') &&
            html.querySelector('[data-color-scheme]').dataset.colorScheme;
          this.modal.setSizes(`m-sharing m-gradient ${colorScheme}`);
          this.modal.open();
          this.trapModalFocus();
        }
      },
    });
  }

  trapModalFocus() {
    if (typeof trapVendorModalFocus === 'function') {
      trapVendorModalFocus(this.modal.modal, this.modal.modalContent, this.triggerElement);
    }
  }
}
customElements.define('m-sharing', MSharing);
